import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trophy, Copy } from "lucide-react";
import api from "../api";

const br = (iso) => new Date(iso).toLocaleDateString("pt-BR");
const month = (p) => p.split("-").reverse().join("/");

export const RewardCoupons = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/me/rewards").then(r => setItems(r.data.filter(c => c.status === "active"))).catch(() => {}); }, []);
  if (!items.length) return null;

  return (
    <div className="space-y-3 mb-6" data-testid="reward-coupons">
      {items.map(c => (
        <div key={c.coupon_id} className="card-arya p-6 border-2 border-[var(--sun-500)] bg-[rgba(233,204,133,.15)] flex flex-wrap items-center gap-4 justify-between" data-testid={`my-reward-${c.coupon_id}`}>
          <div className="flex items-center gap-3">
            <span className="w-12 h-12 rounded-full grid place-items-center bg-[var(--sun-500)] text-white"><Trophy size={20}/></span>
            <div>
              <p className="font-serif text-2xl">Você foi a embaixadora do mês {month(c.period)}!</p>
              <p className="text-sm">Seu prêmio: <b>{c.prize}</b> · válido até {br(c.expires_at)}</p>
            </div>
          </div>
          <div className="text-right">
            <p className="text-[10px] tracking-widest font-display text-[color:var(--sun-700)]">MOSTRE NO ESTÚDIO</p>
            <button onClick={() => { navigator.clipboard.writeText(c.code); toast.success("Código copiado!"); }}
                    className="font-mono text-xl tracking-widest text-[color:var(--sun-700)] inline-flex items-center gap-2" data-testid={`my-reward-code-${c.coupon_id}`}>
              {c.code} <Copy size={14}/>
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};
